import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon, PrinterIcon } from "lucide-react";
import { useEffect } from "react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useQCStandardQuery } from "../api/queries";
import { QCPdfPreviewContent } from "../ui/QCPdfPreviewContent";

export function QCPdfPreviewPage() {
  const { id } = useParams({ from: "/app/qc/$id/pdf-preview" });
  const nav = useNavigate({ from: "/app/qc/$id/pdf-preview" });

  const { data: qc, isLoading, error } = useQCStandardQuery(id);

  // Set document title for print filename
  useEffect(() => {
    if (qc?.name && id) {
      const qcIdShort = id.slice(-6).toUpperCase();
      document.title = `${qc.name} - QC-${qcIdShort}`;
    }
    return () => {
      // Reset to default title when component unmounts
      document.title = "freedom® Admin";
    };
  }, [qc?.name, id]);

  const handleBack = () => {
    nav({ to: "/app/qc/$id", params: { id } });
  };

  const handlePrint = () => {
    window.print();
  };

  if (isLoading) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-primary border-b-2" />
              <p className="mt-2 text-muted-foreground">ກໍາລັງໂຫຼດ...</p>
            </div>
          </div>
        </Main>
      </>
    );
  }

  if (error || !qc) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <h2 className="mb-2 font-bold text-2xl text-destructive">
                ບໍ່ພົບມາດຕະຖານ QC
              </h2>
              <p className="mb-4 text-muted-foreground">
                ມາດຕະຖານ QC ທີ່ທ່ານຊອກຫາບໍ່ມີຢູ່ ຫຼື ຖືກລຶບໄປແລ້ວ
              </p>
              <Button onClick={handleBack}>
                <ArrowLeftIcon className="mr-2 h-4 w-4" />
                ກັບໄປທີ່ QC
              </Button>
            </div>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />

      <Main>
        {/* Header Actions - Hidden in print */}
        <div className="mb-6 flex items-center justify-between print:hidden">
          <Button variant="ghost" onClick={handleBack} className="gap-2">
            <ArrowLeftIcon className="h-4 w-4" />
            ກັບໄປທີ່ QC
          </Button>

          <div className="flex items-center gap-2">
            <Button variant="outline" onClick={handlePrint} className="gap-2">
              <PrinterIcon className="h-4 w-4" />
              ພິມ
            </Button>
          </div>
        </div>

        {/* PDF Preview Content */}
        <QCPdfPreviewContent qc={qc} />
      </Main>
    </>
  );
}
